import { init } from '@nuskin/ns-util'

export default async () => {
  const locale = (new URLSearchParams(window.location.search)).get('locale') || 'en_US'
  const [language, country] = locale.split('_')

  const initConfig = {
    language,
    country,
    envCode: process.env.VUE_APP_CONTENT_STACK_ENVIRONMENT,
    siteConfigurationPath: undefined,
    clientId: '735b1eb810304bba966af0891ab54053',
    clientSecret: '0deea37049e84157A406C0C01D29F300'
  }

  if ((window && window.location && window.location.host || '').includes('localhost')) {
    initConfig.baseUrl = '/'
  }

  init(initConfig)
}
